module.exports = __webpack_public_path__ + "images/frontpage@1x.png?4da97d54";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/frontpage@1x.png
// module id = 624
// module chunks = 7